export default {"src":"/_next/static/media/Notifications.b90df077.svg","height":257,"width":417,"blurWidth":0,"blurHeight":0};